<template>
  <div class="cabecera">
    <input-fecha-hora
      v-model="fechaCuaderno"
      :fixed-width="true"
      class="selector-fecha m-n"
      :unselectable="false"
      :available-dates="fechasValidas"
    />
    <button
      v-for="ch in sesiones"
      :key="ch.id"
      :class="`btn btn-sm btn-${ch.id === horarioActualId ? 'success' : 'default'}`"
      type="button"
      @click="gotoHorario(ch)"
    >
      {{ ch.hora_inicio }} -
      {{ ch.hora_fin }}
    </button>
    <div class="titulo-evaluacion">
      {{ evaluacion.nombre }}
    </div>
    <slot name="botonesExtras"></slot>
    <component
      :is="preferenciasView"
      v-if="preferenciasView"
      :info-cuaderno="infoCuaderno"
      class="btn-preferencias"
      @recargar-cuaderno="$emit('recargarCuaderno', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    fecha: { type: String, required: true },
    fechasValidas: { type: Array, required: true },
    horarios: { type: Array, required: false, default: () => [] },
    horarioActualId: { type: Number, required: false, default: undefined },
    evaluacion: { type: Object, required: true },
    preferenciasView: { type: Object, required: false, default: undefined },
    infoCuaderno: { type: Object, required: false, default: undefined },
  },
  emits: ['cambio-fecha', 'cambio-horario', 'recargarCuaderno'],
  data() {
    return {
      fechaCuaderno: this.fecha,
    };
  },
  computed: {
    /*
    Nos llegan todos los horarios pero las asistencias van por celda horario porque en la misma
    celda de 8 a 9 puede haber 3 pastillas de 3 profes distintos que dan clase a los mismos niños.
    Aquí lo que hacemos es coger cualquiera de sus horarios porque realmente a la hora de guardar
    se guardará solo su celda (no puedo cambiar todo ahora para usar celdas en vez de horarios en
    el front-end)
     */
    sesiones() {
      const sesiones = {};
      const horarioActual = this.horarios.find((h) => (h.id === this.horarioActualId));
      if (horarioActual) {
        sesiones[horarioActual.celda_horario.id] = horarioActual;
      }
      this.horarios.forEach((horario) => {
        if (!(horario.celda_horario.id in sesiones)) {
          sesiones[horario.celda_horario.id] = horario;
        }
      });
      return Object.values(sesiones).sort((h) => (h.hora_inicio));
    },
  },
  watch: {
    fecha(value) {
      this.fechaCuaderno = value;
    },
    fechaCuaderno(value) {
      this.$emit('cambio-fecha', value);
    },
  },
  methods: {
    gotoHorario(value) {
      this.$emit('cambio-horario', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../assets/stylesheets/cifra/vars/main.scss";

  :deep(.vc-popover-content-wrapper) {
    z-index: 1001 !important;
  }

  .cabecera {
    display: flex;
    align-items: center;
    padding: 4px;
  }

  .cabecera button {
    margin-left: 4px;
  }

  .selector-fecha {
    margin-right: 10px;
  }

  .titulo-evaluacion {
    font-size: 1.2em;
    flex-grow: 1;
    text-align: center;
  }

  .btn-preferencias {
    margin-left: 10px;
  }
</style>
